<div class="contenedor-filtros p-16">
    <h2 class="m-0">Filtros</h2>
    <mat-divider></mat-divider>
    <br />

    <div
        fxLayoutGap="30px"
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign="space-around center"
    >
       


        <mat-form-field class="full-width">
            <mat-label>Cliente</mat-label>

            <mat-chip-list #clientesList aria-label="Cliente" [multiple]="false">
                <mat-chip
                    class="primary"
                    *ngFor="let clienteSeleccionado of filtros.cliente"
                    [removable]="true"
                    (removed)="quitarFiltro('cliente')"
                >
                    {{ clienteSeleccionado.descripcion }}
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    #clienteInput
                    [formControl]="clienteCtrl"
                    [matAutocomplete]="autoCompleteCliente"
                    [matChipInputFor]="clientesList"
                />
            </mat-chip-list>
            <mat-autocomplete
                #autoCompleteCliente="matAutocomplete"
                (optionSelected)="
                    seleccionarFiltro(
                        $event,
                        'id',
                        'nombre',
                        clienteCtrl,
                        'clienteInput',
                        'cliente'
                    )
                "
            >
                <mat-option
                    *ngFor="let clienteFiltrado of filteredClientes | async"
                    [value]="clienteFiltrado"
                >
                    {{ clienteFiltrado.nombre }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

     

        <mat-form-field class="full-width">
            <mat-label>Rut</mat-label>

            <mat-chip-list #rutList aria-label="Rut" [multiple]="false">
                <mat-chip
                    class="primary"
                    *ngFor="let rutSeleccionado of filtros.rut"
                    [removable]="true"
                    (removed)="quitarFiltro('rut')"
                >
                    {{ rutSeleccionado.descripcion }}
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    #nombreInput
                    [formControl]="rutCtrl"
                    [matChipInputFor]="rutList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="
                        agregarFiltro($event, rutCtrl, 'rut')
                    "
                />
            </mat-chip-list>
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Estado</mat-label>

            <mat-chip-list #estadosList aria-label="Estado" [multiple]="false">
                <mat-chip
                    class="primary"
                    *ngFor="let estadoSeleccionado of filtros.estado"
                    [removable]="true"
                    (removed)="quitarFiltro('estado')"
                >
                    {{ estadoSeleccionado.descripcion }}
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    #estadoInput
                    [formControl]="estadoCtrl"
                    [matAutocomplete]="autoCompleteEstado"
                    [matChipInputFor]="estadosList"
                />
            </mat-chip-list>
            <mat-autocomplete
                #autoCompleteEstado="matAutocomplete"
                (optionSelected)="
                    seleccionarFiltro(
                        $event,
                        'valor',
                        'descripcion',
                        estadoCtrl,
                        'estadoInput',
                        'estado'
                    )
                "
            >
                <mat-option
                    *ngFor="let estadoFiltrado of filteredEstados | async"
                    [value]="estadoFiltrado"
                >
                    {{ estadoFiltrado.descripcion }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
    <div fxLayoutGap="10px" fxLayout="row" fxLayoutAlign="start start">
        <button
            mat-raised-button
            color="primary"
            (click)="limpiarTodosFiltros()"
        >
            <mat-icon>clear</mat-icon>
            Limpiar filtros
        </button>
        <button mat-raised-button color="accent" (click)="filtrar()">
            <mat-icon>tune</mat-icon> Filtrar
        </button>
    </div>
</div>
